import { writable } from 'svelte/store';

export const selectedItemId = writable();
export const hoveredItemId = writable();
export const modeId = writable();
